import script from "./Tabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tabs.vue?vue&type=script&lang=ts&setup=true"

import "./Tabs.vue?vue&type=style&index=0&id=5e3d7626&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3d7626"]])

export default __exports__